/* eslint-disable no-console */
import SiteModal from './site-modal';

export default class ToggleContentToModal {
  constructor(options) {
    this.modalId = options.modalId;
    this.toggleSelector = options.toggleSelector;
    this.toggleContent = options.toggleContent;
    this.prevWinWidth = 999999;
    this.mobileBrkpt = 768;
    this.toggleBtn = document.querySelector(this.toggleSelector);
    this.callbacks = options.callbacks;
    if (!this.toggleBtn) {
      return;
    }

    if (!this.callbacks) {
      this.callbacks = {};
    }

    // Modal
    this.modal = new SiteModal({
      id: this.modalId,
      callbacks: {
        onOpen: () => {
          if (this.callbacks.onOpen) {
            this.callbacks.onOpen();
          }
        },
        onClose: () => {
          if (this.callbacks.onClose) {
            this.callbacks.onClose();
          }
        },
      },
      toggleBtn: this.toggleBtn,
    });
    window.addEventListener('resize', this.onResize.bind(this));
    this.updateContentOnResize();
  }

  appendToModal() {
    // console.log(`${window.innerWidth}, ${this.modalId}, appendToModal`);
    this.toggleContent.forEach((item) => {
      const filters = document.querySelector(item.content);
      const wrapper = document.querySelector(item.modalSelector);
      wrapper.append(filters);
    });
  }

  detatchFromModal() {
    // console.log(`${window.innerWidth}, ${this.modalId}, detatchFromModal`);
    this.toggleContent.forEach((item) => {
      const filters = document.querySelector(item.content);
      const wrapper = document.querySelector(item.defaultSelector);
      wrapper.append(filters);
    });
  }

  updateContentOnResize() {
    if (window.innerWidth >= this.mobileBrkpt && this.prevWinWidth < this.mobileBrkpt) {
      this.detatchFromModal();
      this.prevWinWidth = window.innerWidth;
      // Hide modal when reizing from mobile to desktop
      this.modal.close();
    }
    if (window.innerWidth < this.mobileBrkpt && this.prevWinWidth >= this.mobileBrkpt) {
      this.appendToModal();
      this.prevWinWidth = window.innerWidth;
    }
  }

  onResize() {
    this.updateContentOnResize();
  }
}
/* eslint-enable no-console */
